// import { ReactComponent as EditIcon } from '@common/icons/Edit.svg';
// import { ReactComponent as ReplyIcon } from '@common/icons/Reply.svg';
// import { ReactComponent as ThumbsUpIcon } from '@common/icons/ThumbsUp.svg';
import React, { useState } from 'react';

import StarRating from './StarRating';

// import StarRating from './StarRating';

export interface ReviewProps {
  className?: string;
  rating?: number;
  total?: number;
  name: string;
  date: string;
  review: string;
}
function spliter(dateStr: string) {
  const arr = dateStr.split(' ');
  return arr[2] + ' ' + arr[1] + ' ' + arr[3];
}

const ReviewComponent: React.FunctionComponent<ReviewProps> = ({ name, date, review, rating, className = '' }) => {
  const [isFullData, setIsFullData] = useState(false);
  return (
    <>
      <div className={`w-full bg-white p-16 ${className}`} font-customisation="para-text">
        <div className="flex mb-16">
          <div className="flex-1">
            <div className="text-14 text-heading font-semibold" color-customisation="page-body-text">
              {name}
            </div>
            <div className="text-14 md:text-16 font-medium text-greyGreen">{spliter(date)}</div>
          </div>
          <div>
            {rating != null ? <StarRating rating={rating} total={5} isInteractive={false} className="" /> : null}
          </div>
        </div>
        <div className="text-14 text-body font-medium">
          {review.length > 180 ? (
            <>
              <p>{isFullData ? review : review.substring(0, 180) + '...'}</p>
              <button className="mt-16 text-theme underline" onClick={() => setIsFullData(!isFullData)}>
                {isFullData ? 'View less' : 'View More'}
              </button>
            </>
          ) : (
            review
          )}
        </div>
      </div>
    </>
  );
};

export default ReviewComponent;
